// assets
import { IconEqual, IconEqualNot, IconBusinessplan } from '@tabler/icons';
import ScaleIcon from '@mui/icons-material/Scale';
import ListIcon from '@mui/icons-material/List';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import StorefrontIcon from '@mui/icons-material/Storefront';

// constant
const icons = {
    IconEqual,
    IconBusinessplan,
    IconEqualNot,
    ScaleIcon,
    ListIcon,
    CompareArrowsIcon,
    StorefrontIcon
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const opciones = {
    id: 'opciones',
    title: 'Opciones',
    type: 'group',
    children: [
        {
            id: 'homologadosmt',
            title: 'Homologados',
            type: 'item',
            url: '/homologaciones/homologadosmt',
            target: false,
            icon: icons.IconEqual
        },
        {
            id: 'nohomologadosmt',
            title: 'No homologados',
            type: 'item',
            url: '/homologaciones/no-homologadosmt',
            target: false,
            icon: icons.IconEqualNot
        },
        {
            id: 'tiendasnohomologados',
            title: 'Tiendas Homologadas',
            type: 'item',
            url: '/maestro/tiendasmt',
            target: false,
            icon: icons.IconEqualNot
        },
        {
            id: 'tiendasnohomologados2',
            title: 'Tiendas No Homologadas',
            type: 'item',
            url: '/maestro/tiendasmt-nohomologadas',
            target: false,
            icon: icons.IconEqualNot
        }
        // {
        //     id: 'cloroxTT',
        //     title: 'CloroxTT',
        //     type: 'collapse',
        //     icon: icons.CompareArrowsIcon,
        //     children: [
        //         {
        //             id: 'homologados',
        //             title: 'Homologados',
        //             type: 'item',
        //             url: '/homologaciones/homologados',
        //             target: false,
        //             icon: icons.IconEqual
        //         },
        //         {
        //             id: 'nohomologados',
        //             title: 'No homologados',
        //             type: 'item',
        //             url: '/homologaciones/no-homologados',
        //             target: false,
        //             icon: icons.IconEqualNot
        //         }
        //     ]
        // },
        // {
        //     id: 'cloroxMT',
        //     title: 'CloroxMT',
        //     type: 'collapse',
        //     icon: icons.CompareArrowsIcon,
        //     children: [
        //         {
        //             id: 'homologadosmt',
        //             title: 'Homologados',
        //             type: 'item',
        //             url: '/homologaciones/homologadosmt',
        //             target: false,
        //             icon: icons.IconEqual
        //         },
        //         {
        //             id: 'nohomologadosmt',
        //             title: 'No homologados',
        //             type: 'item',
        //             url: '/homologaciones/no-homologadosmt',
        //             target: false,
        //             icon: icons.IconEqualNot
        //         },
        //         {
        //             id: 'tiendasnohomologados',
        //             title: 'Tiendas Homologadas',
        //             type: 'item',
        //             url: '/maestro/tiendasmt',
        //             target: false,
        //             icon: icons.IconEqualNot
        //         },
        //         {
        //             id: 'tiendashomologadas',
        //             title: 'Tiendas No Homologadas',
        //             type: 'item',
        //             url: '/maestro/tiendasmt-nohomologadas',
        //             target: false,
        //             icon: icons.IconEqualNot
        //         }
        //     ]
        // }
    ]
};

export default opciones;
